/**
 * Tabla SUNAT / PLAME de tipo de documento de identidad (2 dígitos).
 * 01 DNI · 04 Carné de extranjería · 07 Pasaporte
 */
export function codigoTipoDocumentoPlame(tipoDocumento) {
  const tipo = String(tipoDocumento || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

  if (tipo.includes('extranjer')) return '04';
  if (tipo.includes('pasaporte')) return '07';
  return '01';
}

export default codigoTipoDocumentoPlame;
